import React from "react";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const tabs = [
  {
    id: "docType",
    title: "Documents Type",
    icon: "ri-bar-chart-line",
    path: "/documents/type",
    activePaths: ["/documents/type"],
  },
  {
    id: "documents",
    title: "Documents",
    icon: "ri-file-text-line",
    path: "/student/documents",
    activePaths: ["/student/documents"],
  },
];

export default function Master({ children }) {
  return;
  return (
    <>
      <ModuleHeader tabs={tabs} />
      {children}
    </>
  );
}